<template>
  <table class="table the-datatable" id="datatable">
    <thead>
      <tr>
        <th
          v-for="column in columns"
          :key="column.name"
          @click="
            column.sortable ? (sortByColumn(column.name), updateArrows($event, column.name)) : ''
          "
          :style="
            'width:' +
              column.width +
              ';position:relative;' +
              (column.sortable ? 'cursor:pointer;' : 'user-select:none;')
          "
        >
          <span>
            {{ column.label }}
            <i v-if="column.sortable" class="fa fa-sort sorting-arrow" ref="isort"></i>
            <span
              v-if="column.searchable"
              @click="singleSearch($event, column.name, column.label)"
              class="fa fa-search legitRipple"
            ></span>
          </span>

          <input
            id="mainCheck"
            v-if="column.label === ''"
            type="checkbox"
            @click="checkMainCheck()"
          />
        </th>
      </tr>
    </thead>
    <slot></slot>
  </table>
</template>

<script>
export default {
  props: [
    'columns',
    'sortKey',
    'sortOrders',
    'sortByColumn',
    'sortDir',
    'searchOneCol',
    'checkAll',
    'unCheckAll',
    'loggedInUserData'
  ],
  methods: {
    checkMainCheck() {
      if ($('#mainCheck').is(':checked')) {
        this.checkAll()
      } else {
        this.unCheckAll()
        $('#mainCheck').is(':checked')
      }
    },

    updateArrows(event, columnName) {
      var el = $(event.target).children('i')
      var className = ''

      className = this.sortDir === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'
      $('.the-datatable th i').attr('class', 'fa fa-sort')
      el.attr('class', className)
    },

    singleSearch(event, columnName, columnLabel) {
      event.stopPropagation()
      swal('Search ' + columnLabel, {
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Type to search',
            className: 'form-control'
          }
        },
        buttons: [this.Cancel, this.Search]
      }).then(value => {
        if (value) {
          this.searchOneCol(columnName, value)
        }
      })
    }
  }
}
</script>

<style scoped>
th {
  font-weight: bold;
  color: #273246;
}
.fa-sort {
  color: #bbb;
  pointer-events: none;
}
.fa-sort-down,
.fa-sort-up {
  color: blue;
  pointer-events: none;
}

.editable-container {
  position: absolute;
  top: 100px;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/components/Datatable.vue